export const GET_APPLICATION_CONFIG = 'GET_APPLICATION_CONFIG';
export const GET_PREMIUM_CONFIGURATION = 'GET_PREMIUM_CONFIGURATION';
export const GET_PLATFORM_CONFIGURATION_REQUEST = 'GET_PLATFORM_CONFIGURATION_REQUEST';
export const GET_PLATFORM_CONFIGURATION_SUCCESS = 'GET_PLATFORM_CONFIGURATION_SUCCESS';
export const GET_PLATFORM_CONFIGURATION_FAILURE = 'GET_PLATFORM_CONFIGURATION_FAILURE';
export const UPDATE_PLATFORM_CONFIGURATION_REQUEST = 'UPDATE_PLATFORM_CONFIGURATION_REQUEST';
export const UPDATE_PLATFORM_CONFIGURATION_SUCCESS = 'UPDATE_PLATFORM_CONFIGURATION_SUCCESS';
export const UPDATE_PLATFORM_CONFIGURATION_FAILURE = 'UPDATE_PLATFORM_CONFIGURATION_FAILURE';